const routes = [
  {
    path: '/chongzhou/1',
    name: 'chongzhou1',
    meta: {
      title: '崇州市推进“蜀城英才绿卡·五安工程”服务体系建设的实施方案'
    },
    component: () => import('./1.vue')
  },
  {
    path: '/chongzhou/2',
    name: 'chongzhou2',
    meta: {
      title: '崇州市做强产业建圈强链人才支撑的十条措施'
    },
    component: () => import('./2.vue')
  }
]

export default routes